// Utility to wrap fetch and inject X-Pool-ID header from env

const POOL_ID = process.env.REACT_APP_POOL_ID || '';

export async function apiFetch(input: RequestInfo, init: RequestInit = {}) {
  const headers = new Headers(init.headers || {});
  if (POOL_ID) {
    headers.set('X-Pool-ID', POOL_ID);
  }
  return fetch(input, { ...init, headers });
}
